module.exports = __webpack_public_path__ + "img/syukyaku-kyoutu-ira002.959d88e8.png";